import { render, staticRenderFns } from "./LicencesHoldbackGrid.vue?vue&type=template&id=f5a0eb9e&scoped=true&"
import script from "./LicencesHoldbackGrid.vue?vue&type=script&lang=js&"
export * from "./LicencesHoldbackGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a0eb9e",
  null
  
)

export default component.exports